/**
 * The chart
 * @flow
 */
import React, { useMemo } from "react";
import Path from "./Path";
import * as Types from "./NextGenChartTypes";

export type Props = {
  data: Array<Types.RenderablePoint>,
  width: number,
  height: number,
  scaleX: (date: number) => number,
  scaleY: (value: number) => number,
  strokeWidth: number,
  color: string,
  displayGradient: boolean
};

const Curve = React.memo(function({
  data,
  displayGradient,
  width,
  height,
  scaleX,
  scaleY,
  strokeWidth,
  color
}: Props) {

  let id = useMemo(() => {
    let i = Math.random().toString(36).slice(2, 8)
    return i;
  }, []);

  if (data.length < 2) {
    return null;
  }

  return (
    <g>
      <defs>
        <linearGradient
          id={id}
          gradientUnits="userSpaceOnUse"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor={color} stopOpacity={0.25} />
          <stop offset="100%" stopColor={color} stopOpacity={0} />
        </linearGradient>
      </defs>

      {displayGradient && (
        <Path
          data={data}
          curved={false}
          shadow={true}
          viewportWidth={width}
          viewportHeight={height}
          fill={`url(#${id})`}
        />
      )}

      <Path
        data={data}
        curved={false}
        shadow={false}
        viewportWidth={width}
        viewportHeight={height}
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </g>
  );
});

export default Curve;



// WEBPACK FOOTER //
// ./src/components/Chart/Line.js